import React from 'react';

import 'react-toastify/dist/ReactToastify.css';

import Widget from '../../../components/Widget';
import s from '../Afiliaciones.module.scss';
import Comercios from "./comercios";


class Resumen extends React.Component{
    // state = {
    //     data : []
    // }
    // API_URL = "/resume"
    //
    // componentDidMount() {
    //     fetch(this.API_URL)
    //         .then((response) => response.json())
    //         .then((data) => {
    //             console.log(data)
    //             this.setState({
    //                 data: data
    //             })
    //         });
    // }

    render() {
        return (
            <div className={s.root}>
                <Widget>
                    <Comercios data = {this.props.data} />
                </Widget>
            </div>
        );
    }

}

export default Resumen;
